//React
import React from "react";
import {
  NavLink,
} from "react-router-dom";



class Comp extends React.Component {
  render() {
    return (
      <div className='sub_menu' style={{maxWidth:'300px', margin:'auto'}}>
        <div className='outer'>
          <NavLink to="/footprint/partner/" exact className='link' activeClassName="selected">
            <div className='text' style={{padding:'10px'}}>相手から</div>
          </NavLink>
          <NavLink to="/footprint/my/" className='link' activeClassName="selected">
            <div className='text' style={{padding:'10px'}}>自分から</div>
          </NavLink>
        </div>
      </div>
    )
  }
}

export default Comp;
